import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CuentasPagoGuiaComponent, validar as validarPagoGuias } from "./pagoguias";
type Entity = models.ConfigContabilidadCuentasGuias;

export interface Props {
    value: Entity;
    label: string;
    error?: kea.FieldError;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        Contado: validation.subrule(validarPagoGuias),
        CreditoFacturado: validation.subrule(validarPagoGuias),
        CreditoNoFacturado: validation.subrule(validarPagoGuias),
    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un cuenta guias
*/
export class GuiasComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Pago = getField(CuentasPagoGuiaComponent);

        return (
            <div>
                <kea.Panel title={this.props.label} error={this.props.error}>
                    <Pago field="Contado" />
                    <Pago field="CreditoFacturado" />
                    <Pago field="CreditoNoFacturado" />
                </kea.Panel>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/configuraciones/edit/components/contabilidad/guias.tsx